import { render, staticRenderFns } from "./ClosedNotices.vue?vue&type=template&id=7ecbd249&"
import script from "./ClosedNotices.vue?vue&type=script&lang=js&"
export * from "./ClosedNotices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports